// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ikIuP","list":"styles_list__B9SqE"};